/** Dates are rendered from the journal date, never stored as text (SPEC §4). Device-local days (D21). */
const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
const WEEKDAYS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']

export function todayKey(d = new Date()): string {
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`
}

/** "Oct 12th, 2026" and "Monday". */
export function dayTitle(date: string): { title: string; weekday: string } {
  const [y, m, d] = date.split('-').map(Number) as [number, number, number]
  const wd = new Date(y, m - 1, d).getDay()
  const suffix = d % 10 === 1 && d !== 11 ? 'st' : d % 10 === 2 && d !== 12 ? 'nd' : d % 10 === 3 && d !== 13 ? 'rd' : 'th'
  return { title: `${MONTHS[m - 1]} ${d}${suffix}, ${y}`, weekday: WEEKDAYS[wd]! }
}
